import { compareDataTableColumn } from "@/config/tableColumnConfig";
import _ from "lodash";
export function getCurrentColumn(visableColumns, dataTable) {
  const dateFilter = dataTable.dateFilter;
  const allColumns = {};
  const isCompare = Boolean(dateFilter.startDate2 && dateFilter.endDate2);
  const dateRanges = [
    [dateFilter.startDate1, dateFilter.endDate1],
    [dateFilter.startDate2, dateFilter.endDate2],
  ];
  _.forEach(
    compareDataTableColumn(
      dateRanges,
      dataTable.typeGrouping,
      dataTable.dateGrouping,
      isCompare
    ),
    (col) => {
      const existColumns = visableColumns.find((v) => v.field === col.field);
      if (isCompare) {
        if (
          (col.field.includes("all") &&
            visableColumns.find((v) => v.field.includes("all"))) ||
          (col.field.includes("promoter_actual") &&
            visableColumns.find((v) => v.field.includes("promoter_actual")))
        ) {
          allColumns[col.field] = true;
        } else {
          allColumns[col.field] = existColumns ? true : false;
        }
      } else {
        allColumns[col.field] = existColumns ? true : false;
      }
    }
  );
  return allColumns;
}
